if (!customElements.get('wls-collection-tier')) {
  class WlsCollectionTier extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        grid: 'wls-collection-tier__grid',
        product: 'wls-collection-tier__product',
        productHidden: 'hidden',
        expandButton: 'js-collection-tier-expand',
        expanded: 'is-expanded',
      };

      this.bind = {
        onExpandClick: this._onExpandClick.bind(this),
      };
    }

    /**
     * Returns key nodes scoped to this element.
     *
     * @returns {{
     *   expandButton: NodeListOf<Element>;
     *   hiddenProducts: NodeListOf<Element>;
     * }}
     */
    get elements() {
      return {
        expandButton: this.querySelectorAll(`.${this.classes.expandButton}`),
        hiddenProducts: this.querySelectorAll(
          `.${this.classes.product}.${this.classes.productHidden}`
        ),
      };
    }

    /**
     * Sets up expand behaviour when `data-view-all-style="expand"`.
     *
     * @returns {void}
     */
    connectedCallback() {
      if (this.dataset.viewAllStyle !== 'expand') return;
      this._setupExpand();
    }

    /**
     * Removes event listeners.
     *
     * @returns {void}
     */
    disconnectedCallback() {
      const { expandButton } = this.elements;
      expandButton.forEach((el) => el.removeEventListener('click', this.bind.onExpandClick));
    }

    // ─── Expand ──────────────────────────────────────────────────────────────

    /**
     * Binds the expand button click handler.
     * If there are no hidden products the button is hidden immediately.
     *
     * @returns {void}
     */
    _setupExpand() {
      const { expandButton, hiddenProducts } = this.elements;
      if (!expandButton.length) return;

      if (!hiddenProducts.length) {
        expandButton.forEach((el) => (el.hidden = true));
        return;
      }

      this._overflowProducts = Array.from(hiddenProducts);
      expandButton.forEach((el) => el.addEventListener('click', this.bind.onExpandClick));
    }

    /**
     * Toggles overflow product cards and the expanded state.
     *
     * @returns {void}
     */
    _onExpandClick() {
      const isExpanded = this.classList.contains(this.classes.expanded);

      if (isExpanded) {
        this._overflowProducts.forEach((el) => el.classList.add(this.classes.productHidden));
        this.classList.remove(this.classes.expanded);
      } else {
        this._overflowProducts.forEach((el) => el.classList.remove(this.classes.productHidden));
        this.classList.add(this.classes.expanded);
      }
    }
  }

  customElements.define('wls-collection-tier', WlsCollectionTier);
}
